import { Card, alpha, styled } from '@mui/material';

export const CustomContentCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2.5),
  width: '100%',
  minHeight: 185,
  boxShadow: 'none',
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,

  '&:hover, &.selected': {
    borderColor: alpha(theme.palette.secondary.main, 0.24),
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    boxShadow: theme.shadows[20],
  },

  '& .checkbox': {
    display: 'none',
  },
  '& .thumbnail': {
    display: 'block',
  },

  '&:hover .checkbox, &.selected .checkbox': {
    display: 'block',
  },
  '&:hover .thumbnail, &.selected .thumbnail': {
    display: 'none',
  },
}));
